<script setup>
import { ref } from "vue";

const message = ref("");
const description = ref("");
const formIsVisible = ref(false);

// TODO: modernize to obviate cldrSurvey.testsToHtml, v-html, and this entire file
// Reference: https://unicode-org.atlassian.net/browse/CLDR-18013

/**
 * Display a notification
 *
 * @param {String} mess the title message, displayed at the top
 * @param {String} desc the more detailed description, which may be HTML
 */
function openWithMessageAndDescription(mess, desc) {
  message.value = mess;
  description.value = desc;
  formIsVisible.value = true;
}

function onClose() {
  formIsVisible.value = false;
  message.value = description.value = "";
}

defineExpose({
  openWithMessageAndDescription,
});
</script>

<template>
  <!-- The dialog layout and functionality are intended to resemble those of the dialogs
   produced by cldrNotification.open, which is implemented with notification.open from Ant Design Vue.
   One difference is that HTML is supported here for the description, which in general may come from
   HTML messages generated by the Survey Tool back end.

   References:
     https://antdv.com/components/notification
     https://antdv.com/components/modal
  -->
  <a-modal
    v-model:visible="formIsVisible"
    :title="message"
    :footer="null"
    :maskClosable="false"
    :keyboard="false"
    style="top: 24px; right: 24px; position: absolute"
    @ok="onClose"
  >
    <div v-html="description" />
  </a-modal>
</template>
